import { render, staticRenderFns } from "./brokerInsuredManagement.vue?vue&type=template&id=45ef96cf&scoped=true"
import script from "./brokerInsuredManagement.vue?vue&type=script&lang=js"
export * from "./brokerInsuredManagement.vue?vue&type=script&lang=js"
import style0 from "./brokerInsuredManagement.vue?vue&type=style&index=0&id=45ef96cf&prod&scoped=true&lang=css"
import style1 from "./brokerInsuredManagement.vue?vue&type=style&index=1&id=45ef96cf&prod&lang=css"
import style2 from "./brokerInsuredManagement.vue?vue&type=style&index=2&id=45ef96cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef96cf",
  null
  
)

export default component.exports